var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFitness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Fitness-Dumbbell--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Fitness Dumbbell Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.6 2.21a1.5 1.5 0 1 0 -2.12 2.12l2.83 2.83a0.5 0.5 0 0 1 0 0.7l-5.45 5.45a0.48 0.48 0 0 1 -0.7 0l-2.83 -2.83a1.5 1.5 0 0 0 -2.12 2.13l9.19 9.19a1.51 1.51 0 0 0 2.12 0 1.49 1.49 0 0 0 0 -2.12l-2.83 -2.83a0.51 0.51 0 0 1 0 -0.71l5.45 -5.45a0.51 0.51 0 0 1 0.7 0l2.83 2.83a1.5 1.5 0 1 0 2.12 -2.12Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.56 6.8 -1.41 -1.41A0.47 0.47 0 0 1 22 5a0.49 0.49 0 0 1 0.15 -0.36 2 2 0 1 0 -2.83 -2.83A0.47 0.47 0 0 1 19 2a0.49 0.49 0 0 1 -0.36 -0.15L17.2 0.44a1.5 1.5 0 0 0 -2.12 2.12l6.36 6.37a1.5 1.5 0 1 0 2.12 -2.13Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56 15.08A1.5 1.5 0 0 0 0.44 17.2l1.41 1.41A0.47 0.47 0 0 1 2 19a0.49 0.49 0 0 1 -0.15 0.36 2 2 0 0 0 2.83 2.83 0.5 0.5 0 0 1 0.71 0l1.41 1.37a1.5 1.5 0 0 0 2.12 -2.12Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFitness);
export default ForwardRef;